import React from 'react';
import classNames from 'classnames';
import 'react-grid-layout/css/styles.css';
import { WidgetsKindEnum } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import { draggableHandle } from '../../constants';
import WidgetWrap from '../WidgetWrap';
import styles from './GridLayoutItem.module.scss';

interface GridLayoutItemProps {
  children: React.ReactNode;
  isEditMode?: boolean;
  widgetKind?: string;
  onEdit?: () => void;
  onRemove?: () => void;
}

function isBlueBackgroundWidget(kind?: string): boolean {
  return (
    kind === WidgetsKindEnum.Clock ||
    kind === WidgetsKindEnum.WeatherToday ||
    kind === WidgetsKindEnum.WeatherWeek
  );
}

export default function GridLayoutItem({
  children,
  isEditMode = false,
  widgetKind,
  onEdit,
  onRemove,
}: GridLayoutItemProps) {
  const isBlue = isBlueBackgroundWidget(widgetKind);

  const gridItemClass = classNames(styles.gridItem, {
    [styles.blueBackground]: isBlue,
  });

  const dragHandleClass = classNames(draggableHandle, styles.dragHandle, {
    [styles.dragHandleLight]: isBlue,
  });

  return (
    <div className={gridItemClass}>
      {isEditMode && (
        <>
          <MaterialIcon
            className={dragHandleClass}
            icon="drag_indicator"
            size="md-16"
          />
          <span className={styles.actionsMask} />
          <div className={styles.actions}>
            <IconButton
              icon="edit"
              type={IconButtonTypes.PrimaryOutlined}
              symbolsOutlined
              onClick={onEdit}
            />
            <IconButton
              icon="delete"
              type={IconButtonTypes.NegativeOutlined}
              symbolsOutlined
              onClick={onRemove}
            />
          </div>
        </>
      )}
      <WidgetWrap isBlueBackground={isBlue}>{children}</WidgetWrap>
    </div>
  );
}
